import { validate } from 'compare-versions'

const params = new URLSearchParams(location.search)

// Native always puts app_version on the WebView URL — asserted loudly at
// startup: a missing or malformed value is a native regression better caught
// as a broken page in QA than as silently version-gated features.
const rawAppVersion = params.get('app_version')
if (rawAppVersion === null || !validate(rawAppVersion)) {
  throw new Error(`invalid app_version query param: ${String(rawAppVersion)}`)
}

export const appVersion: string = rawAppVersion

export const language = params.get('language') ?? 'en'

export const shouldMockAPI = params.has('mock')

export const shouldShowDevPanel = params.has('debug')

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = params.get('platform') as Platform
